import React, { useState, useEffect, useRef } from 'react';

/*
*Example

<MultiSelect
	inputStyle={{
		borderBottom: '1px solid #000',
		// borderRadius: '4px',
	}}
	placeholderStyle={{ color: '#000' }}
	itemLabelKey='nome'
	itemIdKey='_id'
	mapKey={'acessType_'}
	data={testUSERSLIST}
	onChange={(val) => { console.log('multiselect: ', val) }}
/>

*/

const MultiSelect = ({ 
	mapKey, 
	itemLabelKey = 'label', 
	itemIdKey = 'id', 
	data, 
	onChange, 
	placeholder = 'Selecione opções...', 
	inputStyle = {}, 
	inputClassName = '', 
	placeholderStyle = {},
	selectedContainerItemsStyle = {} 
}) => {
	const [isOpen, setIsOpen] = useState(false);
	const [selectedItems, setSelectedItems] = useState([]);
	const [searchTerm, setSearchTerm] = useState('');
	const dropdownRef = useRef(null);

	const toggleItem = (item) => {
		const isSelected = selectedItems.some(selected => selected[itemIdKey] === item[itemIdKey]);
		let newSelectedItems;

		if (isSelected) {
			newSelectedItems = selectedItems.filter(selected => selected[itemIdKey] !== item[itemIdKey]);
		} else {
			newSelectedItems = [...selectedItems, item];
		}

		setSelectedItems(newSelectedItems);
		onChange(newSelectedItems);
	};

	const removeItem = (item, e) => {
		e.stopPropagation();
		const newSelectedItems = selectedItems.filter(selected => selected[itemIdKey] !== item[itemIdKey]);
		setSelectedItems(newSelectedItems);
		onChange(newSelectedItems);
	};

	const filteredItems = data.filter(item =>
		item[itemLabelKey]?.toLowerCase()?.includes(searchTerm?.toLowerCase())
	);

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
				setIsOpen(false);
			}
		};

		if (isOpen) {
			document.addEventListener('mousedown', handleClickOutside);
		}

		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [isOpen]);

	return (
		<div className="relative w-full font-sans" ref={dropdownRef}>
			<div
				className={`flex items-center justify-between bg-white cursor-pointer min-h-[47px] ${inputClassName}`}
				style={inputStyle}
				onClick={() => setIsOpen(!isOpen)}
			>
				{selectedItems.length > 0 ? (
					<div className="flex gap-1 flex-1 overflow-hidden">
						{selectedItems.map(item => (
							<div key={item[itemIdKey]} className="flex items-center bg-gray-100 p-0.5 px-1 rounded-sm text-sm" style={selectedContainerItemsStyle}>
								<span className='ml-0 whitespace-nowrap'>{item[itemLabelKey]}</span>
								<button onClick={(e) => removeItem(item, e)} className="border-none bg-transparent cursor-pointer ml-1 text-base text-gray-600">×</button>
							</div>
						))}
					</div>
				) : (
					<div className="text-gray-500 overflow-hidden whitespace-nowrap text-ellipsis" style={placeholderStyle}>{placeholder}</div>
				)}
				<div className="ml-2">{isOpen ? (
					<div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 rotate-180">
						<svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
							<path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
						</svg>
					</div>
				) : (
					<div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
						<svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
							<path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
						</svg>
					</div>
				)}</div>
			</div>

			{isOpen && (
				<div className="absolute w-full max-h-[300px] overflow-y-auto border border-gray-300 rounded-md bg-white z-10 mt-1 shadow-md">
					<input
						type="text"
						className="w-[calc(100%-20px)] p-2 border-none border-b border-gray-200 outline-none"
						placeholder="Buscar..."
						value={searchTerm}
						onChange={(e) => setSearchTerm(e.target.value)}
						onClick={(e) => e.stopPropagation()}
					/>
					<div className="p-1">
						{filteredItems.length > 0 ? (
							filteredItems.map((item, index) => (
								<div
									key={(mapKey || 'mpk') + '_' + item[itemIdKey] + '_' + index}
									className={`flex items-center p-2 cursor-pointer hover:bg-gray-100 ${selectedItems.some(selected => selected[itemIdKey] === item[itemIdKey]) ? 'bg-blue-100' : ''}`}
									onClick={(e) => {
										e.stopPropagation();
										toggleItem(item);
									}}
								>
									<input
										type="checkbox"
										checked={selectedItems.some(selected => selected[itemIdKey] === item[itemIdKey])}
										readOnly
									/>
									<span>{item[itemLabelKey]}</span>
								</div>
							))
						) : (
							<div className="p-2 text-center text-gray-500">Nenhum resultado encontrado</div>
						)}
					</div>
				</div>
			)}
		</div>
	);
};

export default MultiSelect;
